// extracted by mini-css-extract-plugin
export default {"filters":"DashboardFilters_filters__pBXmz","group":"DashboardFilters_group__IFKGA","updateBtn":"DashboardFilters_updateBtn__Ko9OO"};